import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({
  colors: {
    brand: {
      primary: '#FC8B23',
      gray100: '#F7F7F7'
    },
  },
  fonts: {
    body: `'Poppins', sans-serif`
  }
});